// Polling a background Context Graph rebuild (POST /context-graph/{id}/build returns at
// once; GET /context-graph/{id}/status reports rebuild.running until it is done).
//
// Kept out of the page so its three rules can be run under node:
//   * the caller can cancel (customer switch, leaving the page): checked after every wait
//     and every response, so a cancelled poll makes no more requests and reports nothing;
//   * a status request that fails is "status unavailable", never "the rebuild failed" —
//     the rebuild runs on the server whether or not this page can see it;
//   * it gives up after `limit` polls and says the rebuild is still running.

export async function pollRebuild({ getStatus, isCurrent, sleep, limit }) {
  let pollError = null
  for (let i = 0; i < limit; i++) {
    await sleep()
    if (!isCurrent()) return { cancelled: true }
    let status
    try {
      status = await getStatus()
    } catch (err) {
      pollError = err
      continue
    }
    if (!isCurrent()) return { cancelled: true }
    pollError = null
    if (!status?.rebuild?.running) {
      return { cancelled: false, outcome: status?.rebuild?.last || { state: 'unknown' }, pollError: null }
    }
  }
  return { cancelled: false, outcome: null, pollError }
}

// The banner text for a finished poll, or null when there is nothing to say.
export function rebuildMessage({ outcome, pollError }) {
  if (outcome?.state === 'failed') {
    return `Rebuild failed: ${outcome.error || 'unknown error'}. The previous graph is still in use.`
  }
  if (outcome) return null
  if (pollError) {
    return `Rebuild status unavailable (${pollError.message || 'request failed'}). The previous graph stays in use until the rebuild finishes; reload later to check.`
  }
  return 'The rebuild is still running. The previous graph stays in use until it finishes; reload later to see the new one.'
}
